import { CarouselView } from '@component/product-pool-media';
import LOGGER from '@component/common/src/util/Logger';
import '../scss/_dontExtract_/redesign-theme-v3/main.scss';

import { createCarouselView } from '../util/CustomCarouselTypeDecider';
import Util from '../util/Util';

const {
  PAGE_SHOWN_EVENT,
  LAST_PAGE_EVENT,
  NEXT_EVENT,
  PREV_EVENT,
  READY_EVENT,
  SWIPE_EVENT,
} = require('@component/carousel');

let idConsecutive = 0;

function generateAnalyticsData(data, allItemsId, childViews = {}) {
  const { current, childPerPage } = data;
  // current page is 0 based
  const end = current * childPerPage;
  const pageIds = allItemsId.slice(end - childPerPage, end);
  const pageIdsPos = [];
  for (let i = 0; i < pageIds.length; i += 1) {
    // +1 to make pos 1 based
    const pos = ((current - 1) * childPerPage) + i + 1;
    pageIdsPos.push({ id: pageIds[i], pos });
  }
  return Object.assign({}, data, { pageIdsPos, childViews });
}

function registerItems(collection, productPool) {
  const pool = productPool;
  if (collection) {
    collection.forEach((carouselModel) => {
      const model = carouselModel;
      let id = model.id || model.cid;
      if (!id) {
        idConsecutive += 1;
        id = idConsecutive;
        model.cid = id;
      }
      if (!pool[id]) {
        pool[id] = model;
        pool.allItemIds.push(id);
      }
    });
  }
}

module.exports = CarouselView.extend({

  onPage_shown(params) {
    params.childViews.forEach((item) => {
      item.carouselSwatchImage(item.model.get('traits'));
    });
  },

  renderCarouselItems(collection, ItemView) {
    this.carouselViews = collection.map(model => new ItemView({ model }));
    this.carouselItems = this.carouselViews.map(view => view.render().$el.get(0));
  },

  onRender() {
    try {
      const itemsCollection = this.model.get('productPoolMedia').collection;
      // Trim long product names.
      if (itemsCollection) {
        this.trimLongProductNames(itemsCollection);
      }

      registerItems(itemsCollection, this.itemsPool);
      this.renderCarouselItems(itemsCollection, this.childView);

      const opts = this.buildCarouselOpts(this.carouselItems);
      this.carouselView = createCarouselView(opts.carouselType, opts);
      this.carouselView.on(PAGE_SHOWN_EVENT, (args) => {
        this.triggerMethod(PAGE_SHOWN_EVENT, generateAnalyticsData(args, this.itemsPool.allItemIds, this.carouselViews));
      });
      [LAST_PAGE_EVENT, NEXT_EVENT, PREV_EVENT, READY_EVENT, SWIPE_EVENT].forEach((event) => {
        this.carouselView.on(event, (args) => {
          this.triggerMethod(event, args);
        });
      });

      this.carouselView.render();
    } catch (e) { LOGGER.error(e); }
  },

  addNextPageItems(items) {
    if (items) {
      this.trimLongProductNames(items);
      registerItems(items, this.itemsPool);
      this.renderCarouselItems(items, this.childView);
      this.carouselView.addChildren(this.carouselItems);
    }
  },

  trimLongProductNames(items) {
    items.forEach((item) => {
      const product = item.get('product');
      const {
        name,
      } = product.detail;
      const title = Util.escapeQuotes(name);

      product.detail.title = title;
      product.detail.name = name;

      if (product.detail.bottomOverlay && product.detail.bottomOverlay.text && product.detail.bottomOverlay.text.toLowerCase() === 'more colors') {
        delete product.detail.bottomOverlay.text;
      }
      item.set('product', product, { silent: true });
    });
  },

});
